<template>
  <div class="bkg-color--white mar-top--xl hover--shadow">
    <button v-if="has_dynamics" ref="expandButton" @click="toggleWidget" class="plus-button mar-bottom--0"><span class="plus-button_icon">+</span></button>
    <b-collapse id="collapse1" v-model="widgetIsOpen" class="mt-2 collapse--white">
      <button v-if="has_dynamics" class="data-source data-source--grey data-source--condensed">
        <a :href="dynamicsUrl + redirectMdUrl">
          <svg-icon
          icon-name="dynamics"
          :icon-size="50" />
        <p class="data-source_info-box">Dynamics</p>
        </a>
      </button>
    </b-collapse>
  </div>
</template>
<script>
import SVGIcon from '@/components/SVGIcon.vue'

export default {
  components: {
    'svg-icon': SVGIcon
  },
  data () {
    return {
      widgetIsOpen: false,
      salesforceUrl: process.env.VUE_APP_Salesforce_URL,
      redirectUrl: process.env.VUE_APP_REDIRECT,
      dynamicsUrl: process.env.VUE_APP_Dynamics_URL,
      redirectMdUrl: process.env.VUE_APP_MD_REDIRECT,
      has_dynamics: true
    }
  },
  created () {
    setTimeout(() => {
      var dataType = this.$store.state.data.CRMData[0].type
      if (dataType === 'dynamics') {
        this.has_dynamics = true
      } else {
        this.has_dynamics = false
      }
    }, 400)
  },
  methods: {
    toggleWidget () {
      this.widgetIsOpen ? this.closeWidget() : this.openWidget()
    },
    openWidget () {
      this.widgetIsOpen = true
      this.$refs.expandButton.setAttribute('aria-expanded', true)
      this.$store.dispatch('ux/spotlightElement', { element: this.$el, runAfterTurningOff: this.closeWidget })
    },
    closeWidget () {
      this.widgetIsOpen = false
      this.$refs.expandButton.setAttribute('aria-expanded', false)
      this.$store.dispatch('ux/turnOffSpotlight')
    }
  },
  updated () {
    this.$store.commit('updateLeaderLines')
  }
}
</script>
